export default "__VITE_ASSET__Ct$SV2Zf__"